<div class="modal-backdrop" (click)="close()">
  <section class="modal-panel modal-panel--lg dps-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="dps-title">
    <header class="modal-header">
      <h2 id="dps-title" class="modal-title">{{ copy.title }}</h2>
      <button type="button" class="modal-close-btn" (click)="close()" aria-label="Close">×</button>
    </header>

    <div class="modal-body">
      <div class="dps-warning">
        <strong>{{ copy.warningTitle }}</strong>
        <ul>
          @for (item of copy.warningItems; track item) { <li>{{ item }}</li> }
        </ul>
      </div>

      @if (isLoadingReadiness()) {
        <div class="dps-muted">{{ copy.loadingReadiness }}</div>
      } @else if (readinessError()) {
        <div class="alert-error dps-alert-with-action">
          <span>{{ readinessError() }}</span>
          <button type="button" class="btn-ghost" (click)="loadReadiness()">{{ copy.retryReadiness }}</button>
        </div>
      } @else if (readiness(); as ready) {
        <div class="dps-readiness" [class.dps-readiness--ready]="ready.ready" [class.dps-readiness--blocked]="!ready.ready">
          <span>{{ ready.ready ? copy.readinessReady : copy.readinessBlocked }}</span>
          <small>{{ ready.source_label }} → {{ ready.target_label }}</small>
        </div>
        @if (!ready.enabled) {
          <div class="alert-error">{{ copy.disabledDeployment }}</div>
        }
        @if (ready.missing_env.length > 0) {
          <div class="dps-section">
            <h3>{{ copy.missingEnvTitle }}</h3>
            <div class="dps-chips">
              @for (item of ready.missing_env; track item) { <span>{{ item }}</span> }
            </div>
          </div>
        }
        @if (ready.target_errors.length > 0) {
          <div class="dps-section">
            <h3>{{ copy.targetGuardTitle }}</h3>
            <ul class="dps-list">
              @for (item of ready.target_errors; track item) { <li>{{ item }}</li> }
            </ul>
          </div>
        }
      }

      <div class="dps-status-card">
        <div>
          <span class="dps-label">{{ copy.statusLabel }}</span>
          <strong>{{ statusText }}</strong>
        </div>
        @if (activeJob(); as job) {
          <span class="dps-badge" [class.dps-badge--ok]="job.status === 'completed'" [class.dps-badge--bad]="job.status === 'failed' || job.status === 'blocked' || job.status === 'stale'">{{ job.status }}</span>
        }
      </div>

      @if (dryRunDisabledReason; as reason) {
        <div class="dps-muted dps-disabled-reason">{{ reason }}</div>
      }

      @if (activeJob(); as job) {
        @if (job.progress; as progress) {
          <div class="dps-progress-card" role="status" aria-live="polite">
            <div class="dps-progress-card__header">
              <div>
                <span class="dps-label">{{ copy.progressTitle }}</span>
                <strong>{{ progress.label }}</strong>
              </div>
              <span>{{ progressPercent(job) }}%</span>
            </div>
            <div
              class="dps-progress-track"
              role="progressbar"
              [attr.aria-label]="progress.label"
              aria-valuemin="0"
              aria-valuemax="100"
              [attr.aria-valuenow]="progressPercent(job)"
            >
              <div class="dps-progress-fill" [style.width.%]="progressPercent(job)"></div>
            </div>
            @if (progressDetail(progress); as detail) {
              <small>{{ detail }}</small>
            }
          </div>
        }
        <div class="dps-section">
          <h3>{{ copy.summaryTitle }}</h3>
          <div class="dps-summary">
            @for (entry of summaryEntries(job); track entry.key) {
              <div><span>{{ entry.key }}</span><strong>{{ entry.value }}</strong></div>
            }
          </div>
          @if (hardConflictCount(job) > 0) {
            <div class="alert-error">{{ copy.hardConflict(hardConflictCount(job)) }}</div>
          }
          @if (job.error) { <div class="alert-error">{{ job.error }}</div> }
          @if (job.manifest_digest) {
            <button type="button" class="btn-ghost" (click)="loadManifest(job)" [disabled]="isLoadingManifest()">{{ isLoadingManifest() ? copy.loadingManifest : copy.loadManifest }}</button>
          }
        </div>
      }

      @if (manifestJson()) {
        <pre class="dps-manifest">{{ manifestJson() }}</pre>
      }

      @if (jobs().length > 0) {
        <div class="dps-section">
          <h3>{{ copy.historyTitle }}</h3>
          <div class="dps-history">
            @for (job of jobs(); track job.job_id) {
              <button type="button" (click)="selectJob(job)" [class.dps-history__item--active]="activeJob()?.job_id === job.job_id" class="dps-history__item">
                <span>{{ job.mode }} · {{ job.status }}</span>
                <small>{{ job.created_at | date:'short' }}</small>
              </button>
            }
          </div>
        </div>
      }
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn-ghost" (click)="close()">{{ copy.close }}</button>
      <button type="button" class="btn-ghost" (click)="startDryRun()" [disabled]="!canStartDryRun" [title]="dryRunDisabledReason ?? ''">{{ isStartingDryRun() ? copy.dryRunStarting : copy.dryRun }}</button>
      <button type="button" class="btn-primary" (click)="startApply()" [disabled]="!canApply">{{ isStartingApply() ? copy.applyStarting : copy.apply }}</button>
    </footer>
  </section>
</div>
